import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSessionDataQuery } from "@query";
import { Grid, Container} from "@material-ui/core";
import { ProjectDetails } from "./components/ProjectDetails";
import { SessionPlayer } from "@tools";

export const SessionReplayer = () => {
  const { sessionId, projectUuid } = useParams();

  const [ isLoading, setIsLoading ] = useState(true);
  const [ sessionEvents, setSessionEvents ] = useState([]);
  const [ userInfo, setUserInfo ] = useState(null);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const {
        session,
        customerEmail,
        customerInfo,
        createdAt
      } = await getSessionDataQuery(sessionId);
      
      setSessionEvents(session);
      setUserInfo({ ...customerInfo, email: customerEmail, createdAt });

      setIsLoading(false)
    })();
  }, []);
  
  return (
    <Container className="h-full">
      <Grid
        item
        container
        justifyContent="center"
        alignContent="flex-start"
        className="h-full pt-4"
        spacing={3}
      >
        <SessionPlayer
          isLoading={isLoading}
          events={sessionEvents}
        />
        <ProjectDetails
          projectUuid={projectUuid}
          userInfo={userInfo}
        />
      </Grid>
    </Container>
  );
};


